import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login'

Vue.use(VueRouter)

export const constRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登陆',
      icon: 'el-icon-setting'
    },
    hidden: true
  },
  {
    path: '/wx-user-info',
    name: 'WxUserInfo',
    component: () => import('@/views/wx/WxUserInfo'),
    hidden: true
  },
  {
    path: '/wx_main',
    name: 'WxMain',
    component: () => import('@/views/wx/index'),
    hidden: true
  },
  {
    path: '/wx-car-search',
    name: 'WxCarSearch',
    component: () => import('@/views/WxCarQuery/WxCarSearch'),
    hidden: true
  },
  {
    path: '/wechattest',
    name: 'wechatTest',
    component: () => import('@/views/ReportForm-KPI/wechatTest'),
    hidden: true
  },
  {
    path: '/wx_inbound',
    name: 'WxInbound',
    component: () => import('@/views/wx/product/WxInbound'),
    hidden: true
  },
  {
    path: '/wx_inbound_goods',
    name: 'WxInboundGoods',
    component: () => import('@/views/wx/product/WxInboundGoods'),
    hidden: true
  },
  {
    path: '/wx_outbound',
    name: 'WxOutbound',
    component: () => import('@/views/wx/product/WxOutbound'),
    hidden: true
  },
  {
    path: '/wx_outbound_goods',
    name: 'WxOutboundGoods',
    component: () => import('@/views/wx/product/WxOutboundGoods'),
    hidden: true
  },
  {
    path: '/wx_neiling',
    name: 'WxNeiling',
    component: () => import('@/views/wx/product/WxNeiling'),
    hidden: true
  },
  {
    path: '/wx_neiling_goods',
    name: 'WxNeilingGoods',
    component: () => import('@/views/wx/product/WxNeilingGoods'),
    hidden: true
  }
]

export const asyncRoutes = [
  {
    path: '/',
    redirect: '/kanban',
    name: 'RumTime',
    component: () => import('@/layout'),
    meta: {
      title: '看板',
      icon: 'el-icon-odometer'
    },
    children: [
      {
        path: 'kanban',
        name: 'Kanban',
        component: () => import('@/views/kanban'),
        meta: {
          title: '工作台',
          keepAlive: true,
          hidePageHeader: true
        }
      },
      {
        path: 'customer_kanban',
        component: () => import('@/views/customer-kanban'),
        meta: {
          title: '客户看板',
          keepAlive: true,
          hidePageHeader: true
        }
      },
      {
        path: 'technician_load',
        component: () => import('@/views/technician-load'),
        meta: {
          title: '工作计划看板',
          keepAlive: true
        }
      },
      {
        path: 'delivery_plan',
        component: () => import('@/views/delivery-plan'),
        meta: {
          title: '交车计划看板',
          keepAlive: true
        }
      },
      {
        path: 'work_progress',
        component: () => import('@/views/work-progress'),
        meta: {
          title: '车辆进度对比看板',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/work',
    name: 'Work',
    component: () => import('@/layout'),
    meta: {
      title: '工单',
      icon: 'el-icon-files'
    },
    children: [
      {
        path: 'work_list',
        name: 'WorkList',
        component: () => import('@/views/history-work'),
        meta: {
          title: '工单信息',
          keepAlive: true
        }
      },
      {
        path: 'technician_work_statistics',
        name: 'TechnicianWorkStatistics',
        component: () => import('@/views/statistics/technician-work'),
        meta: {
          title: '技师维修统计',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/layout'),
    meta: {
      title: '报表',
      icon: 'el-icon-data-line'
    },
    children: [
      {
        path: 'CAPACITY_KPI',
        name: 'CAPACITY_KPI',
        component: () => import('@/views/ReportForm-KPI/CAPACITY_KPI'),
        meta: {
          title: '产能KPI',
          keepAlive: true
        }
      },
      {
        path: 'EFFICIENCY_KPI',
        name: 'EFFICIENCY_KPI',
        component: () => import('@/views/ReportForm-KPI/EFFICIENCY_KPI'),
        meta: {
          title: '效率KPI',
          keepAlive: true
        }
      },
      {
        path: 'QUALITY_KPI',
        name: 'QUALITY_KPI',
        component: () => import('@/views/ReportForm-KPI/QUALITY_KPI'),
        meta: {
          title: '质量KPI',
          keepAlive: true
        }
      },
      {
        path: 'GROUP_REPORT_MONTH',
        name: 'GROUP_REPORT_MONTH',
        component: () => import('@/views/ReportForm-KPI/GROUP_REPORT_MONTH'),
        meta: {
          title: '集团月报表',
          keepAlive: true
        }
      },
      {
        path: 'GROUP_REPORT_YEARS',
        name: 'GROUP_REPORT_YEARS',
        component: () => import('@/views/ReportForm-KPI/GROUP_REPORT_YEARS'),
        meta: {
          title: '集团年报表',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/workshop',
    name: 'Workshop',
    component: () => import('@/layout'),
    meta: {
      title: '车间',
      icon: 'el-icon-set-up',
      keepAlive: true
    },
    children: [
      {
        path: 'team_list',
        component: () => import('@/views/team'),
        meta: {
          title: '工组信息',
          keepAlive: true
        }
      },
      {
        path: 'station_list',
        component: () => import('@/views/station'),
        meta: {
          title: '工位信息',
          keepAlive: true
        }
      },
      {
        path: 'procedure',
        component: () => import('@/views/procedure'),
        meta: {
          title: '工序信息',
          keepAlive: true
        }
      },
      {
        path: 'parts_coe',
        component: () => import('@/views/car/parts-coe'),
        meta: {
          title: '系数管理',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/customer-and-car',
    name: 'CustomerAndCar',
    component: () => import('@/layout'),
    meta: {
      title: '客户&车辆',
      icon: 'el-icon-user-solid'
    },
    children: [
      {
        path: 'customer_list',
        component: () => import('@/views/customer'),
        meta: {
          title: '客户信息',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('@/layout'),
    meta: {
      title: '门店',
      icon: 'el-icon-house'
    },
    children: [
      {
        path: 'organ_list',
        component: () => import('@/views/organ'),
        meta: {
          title: '机构信息',
          keepAlive: true
        }
      },
      {
        path: 'user_list',
        component: () => import('@/views/user'),
        meta: {
          title: '用户管理',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('@/layout'),
    meta: {
      title: '商品库存',
      icon: 'el-icon-goods'
    },
    children: [
      {
        path: 'warehouse_list',
        component: () => import('@/views/warehouse'),
        meta: {
          title: '仓库',
          keepAlive: true
        }
      },
      {
        path: 'warehouse_pos_list',
        component: () => import('@/views/warehouse-pos'),
        meta: {
          title: '库位',
          keepAlive: true
        }
      },
      {
        path: 'goods_list',
        component: () => import('@/views/goods'),
        meta: {
          title: '商品',
          keepAlive: true
        }
      },
      {
        path: 'inbound_list',
        component: () => import('@/views/inbound'),
        meta: {
          title: '入库',
          keepAlive: true
        }
      },
      {
        path: 'inbound_goods',
        hidden: true,
        component: () => import('@/views/inbound/inboundgoods'),
        meta: {
          title: '入库单据',
          keepAlive: true
        }
      },
      {
        path: 'outbound_list',
        component: () => import('@/views/outbound'),
        meta: {
          title: '出库',
          keepAlive: true
        }
      },
      {
        path: 'outbound_goods',
        hidden: true,
        component: () => import('@/views/outbound/outboundgoods'),
        meta: {
          title: '出库单据',
          keepAlive: true
        }
      },
      {
        path: 'neiling_list',
        component: () => import('@/views/neiling'),
        meta: {
          title: '内领',
          keepAlive: true
        }
      },
      {
        path: 'neiling_goods',
        hidden: true,
        component: () => import('@/views/neiling/neilinggoods'),
        meta: {
          title: '内领单据',
          keepAlive: true
        }
      },
      {
        path: 'goods_list_in_warehouse',
        component: () => import('@/views/inbound/remaingoodslist'),
        meta: {
          title: '仓库商品',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/system',
    name: 'System',
    component: () => import('@/layout'),
    meta: {
      title: '系统',
      icon: 'el-icon-s-tools'
    },
    children: [
      {
        path: 'brand_list',
        component: () => import('@/views/car/brand'),
        meta: {
          title: '品牌信息',
          keepAlive: true
        }
      },
      {
        path: 'model_list',
        component: () => import('@/views/car/model'),
        meta: {
          title: '车系信息',
          keepAlive: true
        }
      },
      {
        path: 'parts_list',
        component: () => import('@/views/car/parts'),
        meta: {
          title: '施工项目',
          keepAlive: true
        }
      },
      {
        path: 'page_permission',
        component: () => import('@/views/page-permission'),
        meta: {
          title: '门店权限'
        }
      },
      {
        path: 'dict',
        component: () => import('@/views/dict'),
        meta: {
          title: '字典管理'
        }
      },
      {
        path: 'system_log',
        component: () => import('@/views/system-log'),
        meta: {
          title: '系统日志'
        }
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test'),
    hidden: true
  },
  {
    path: '/*',
    name: 'PageNotFound',
    component: () => import('@/views/404'),
    hidden: true
  }
]

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return {}
  },
  routes: constRoutes
})

const router = createRouter()

// https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
document.title = '钣喷e管家'

export default router
